export default __webpack_public_path__ + "static/media/adminLogo.9b37c182.svg";